"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssetAndGetUploadUrlResponseToJSON = exports.CreateAssetAndGetUploadUrlResponseFromJSONTyped = exports.CreateAssetAndGetUploadUrlResponseFromJSON = exports.instanceOfCreateAssetAndGetUploadUrlResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateAssetAndGetUploadUrlResponse interface.
 */
function instanceOfCreateAssetAndGetUploadUrlResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateAssetAndGetUploadUrlResponse = instanceOfCreateAssetAndGetUploadUrlResponse;
function CreateAssetAndGetUploadUrlResponseFromJSON(json) {
    return CreateAssetAndGetUploadUrlResponseFromJSONTyped(json, false);
}
exports.CreateAssetAndGetUploadUrlResponseFromJSON = CreateAssetAndGetUploadUrlResponseFromJSON;
function CreateAssetAndGetUploadUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.CreateAssetAndGetUploadUrlResponseFromJSONTyped = CreateAssetAndGetUploadUrlResponseFromJSONTyped;
function CreateAssetAndGetUploadUrlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'url': value.url,
    };
}
exports.CreateAssetAndGetUploadUrlResponseToJSON = CreateAssetAndGetUploadUrlResponseToJSON;
